import { Grid, Typography } from '@mui/material'
import { Autocomplete } from 'components/Autocomplete/Autocomplete'
import Input from 'components/Input/Input'
import { getIn, useFormikContext } from 'formik'
import theme from 'lib/theme'
import { MandatoryNutrientDetails, NutrientDetail } from 'types/model/product'
import { NutrientFieldType } from './ProductNutrients'

export const MandatoryNutrients = ({
  field,
  mandatoryNutrientDetails,
  measurementCodes,
  index,
}: {
  field: NutrientFieldType
  mandatoryNutrientDetails: MandatoryNutrientDetails
  measurementCodes: { label: string; value: string }[]
  index: number
}) => {
  const { setFieldValue, errors } = useFormikContext()
  const formatFieldName = (name: string) => {
    return `nutrientHeaders.${index}.${name}`
  }
  const formatErrorMessage = (nutrientName: string, fieldName: string) => {
    const errorPath = `nutrientHeaders[${index}].mandatoryNutrientDetails.${nutrientName}.${fieldName}`
    return getIn(errors, errorPath)
  }
  const getQuantityUnitCode = () => {
    if (field.name !== 'energy') {
      const quantityUnit = (
        mandatoryNutrientDetails?.[
          field.name as keyof MandatoryNutrientDetails
        ] as NutrientDetail
      )?.quantityUnit
      return (
        measurementCodes.find((code) => code.value === quantityUnit) || null
      )
    }
    return null
  }
  const getAmountInputName = () => {
    if (field.name !== 'energy') {
      return formatFieldName(`mandatoryNutrientDetails.${field.name}.quantity`)
    }
    return formatFieldName(
      `mandatoryNutrientDetails.energy.${field.amountInputName}`
    )
  }

  return (
    <>
      <Grid item xs={3.5} sx={{ padding: theme.spacing(1) }}>
        <Typography sx={{ fontSize: '18px' }}>
          {field.translatedName}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Input
          errorMessage={formatErrorMessage(
            field.name,
            field.amountInputName || 'quantity'
          )}
          label=''
          name={getAmountInputName()}
          type='text'
          variant='filled'
          marginBottom='32px'
        />
      </Grid>
      <Grid item xs={3}>
        {field.name === 'energy' ? (
          <Typography sx={{ padding: theme.spacing(1), fontSize: '18px' }}>
            {field.unit}
          </Typography>
        ) : (
          <Autocomplete
            options={measurementCodes ?? []}
            onChange={(newUnit) => {
              setFieldValue(
                formatFieldName(
                  `mandatoryNutrientDetails.${field.name}.quantityUnit`
                ),
                newUnit?.value
              )
            }}
            onClear={() =>
              setFieldValue(
                formatFieldName(
                  `mandatoryNutrientDetails.${field.name}.quantityUnit`
                ),
                null
              )
            }
            value={getQuantityUnitCode()}
            name={field.name}
            label=''
          />
        )}
      </Grid>
      <Grid item xs={3}>
        <Input
          errorMessage={formatErrorMessage(
            field.name,
            'dailyValueIntakePercent'
          )}
          label=''
          name={formatFieldName(
            `mandatoryNutrientDetails.${field.name}.dailyValueIntakePercent`
          )}
          type='text'
          variant='filled'
          marginBottom='32px'
        />
      </Grid>
    </>
  )
}
